var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"citytag",class:{selected: _vm.isSelected},on:{"click":_vm.selectNode}},[_vm._v(_vm._s(_vm.city.name))])}
var staticRenderFns = []

export { render, staticRenderFns }